var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"region"},[_c('el-cascader',{attrs:{"options":_vm.regionData,"props":_vm.props,"clearable":"","placeholder":"请选择区域"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }